import React from 'react'

import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
  ChartOptions,
  Filler
} from 'chart.js'
import { Line } from 'react-chartjs-2'

import { abbreviateNumber } from '../utils'
import { calculateGaussianPoints } from './utils'
import { chartArbitraryLine } from './plugins'

ChartJS.register(
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Tooltip,
  Legend
)

ChartJS.register()
interface DistributionPricesChartProps {
  priceM2Mean: number
  priceM2Std: number
  propertyPriceM2: number
}

const calculateMaxValue = (priceMean: number, priceStd: number) => {
  const stdMultiplied = priceStd * 3
  return Number(priceMean + stdMultiplied).toFixed(2)
}

const calculateMinValue = (priceMean: number, priceStd: number) => {
  const stdMultiplied = priceStd * 3
  return Number(priceMean - stdMultiplied).toFixed(2)
}

export const DistributionPricesChart = ({
  priceM2Mean,
  priceM2Std,
  propertyPriceM2
}: DistributionPricesChartProps) => {
  const gaussianPoints = calculateGaussianPoints(priceM2Mean, priceM2Std)
  const maxValue = calculateMaxValue(priceM2Mean, priceM2Std)
  const minValue = calculateMinValue(priceM2Mean, priceM2Std)
  const data: ChartData<'line'> = {
    labels: gaussianPoints.map((point) => point.x),
    datasets: [
      {
        pointBorderWidth: 0,
        pointBorderColor: 'rgba(0, 0, 0, 0)',
        pointHoverBackgroundColor: 'rgba(0, 0, 0, 0)',
        pointBackgroundColor: 'rgba(0, 0, 0, 0)',
        tension: 0.5,
        fill: true,
        borderWidth: 1,
        data: gaussianPoints.map((point) => point.y),
        backgroundColor: 'rgba(3, 104, 254, 0.2)',
        borderColor: '#0368fe'
      }
    ]
  }

  const option: ChartOptions<'line'> = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    },
    onResize(chart, size) {
      chart.canvas.width = size.width
      chart.canvas.height = 171
      chart.canvas.style.height = '171px'
      chart.canvas.style.width = `${size.width}px`
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        display: false,
        type: 'linear'
      },
      y: {
        max: Math.max(...gaussianPoints.map((point) => point.y)) * 1.3,
        grid: {
          display: false
        },
        display: false
      }
    }
  }

  const verticalLine = chartArbitraryLine({
    value: propertyPriceM2,
    contentLabel: 'Tu anuncio'
  })

  return (
    <div className="w-full h-full max-h-[171px]">
      <Line data={data} options={option} plugins={[verticalLine]} />
      <div className="px-5 md:px-8 flex flex-row flex-nowrap items-center justify-between w-full mt-1 text-tertiary-input text-body-bold-m">
        <p>${minValue ? abbreviateNumber({ value: Number(minValue) }) : 0}</p>
        <p>${priceM2Mean ? abbreviateNumber({ value: priceM2Mean }) : 0}</p>
        <p>${maxValue ? abbreviateNumber({ value: Number(maxValue) }) : 0}</p>
      </div>
    </div>
  )
}

export default DistributionPricesChart
